import { parse, theme } from "@config/theme";
import { css } from "linaria";
export const container = parse({
  position: "relative"
}, "c1kz3pqs");

require("./styles.linaria.module.css!=!../../../../node_modules/@linaria/webpack4-loader/lib/outputCssLoader.js?cacheProvider=!./styles.ts");